// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionContainer_root__2kDWK","sectionContent":"SectionContainer_sectionContent__14nQ3","backgroundImageWrapper":"SectionContainer_backgroundImageWrapper__1Cd7j"};